<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Copy Matrix Discounts From One Customer To Another</h4>
						<p class="card-category text-right">Copy Matrix Discounts</p>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-md-6">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>FROM CUSTOMER</mat-label>
									<input matInput [formControl]="fromcustomer" (input)="customerSearch($event.target.value, 'from')" [matAutocomplete]="autoFrom" class="text-right" placeholder="Search customer..." />
									<mat-autocomplete #autoFrom="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setFrom($event.option.value)">
										<mat-option *ngFor="let option of fromresults" [value]="option">
											<b>{{ option.debtorno }}</b> - {{ option.name }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>

							<div class="col-md-6">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>TO CUSTOMER</mat-label>
									<input matInput [formControl]="tocustomer" (input)="customerSearch($event.target.value, 'to')" [matAutocomplete]="autoTo" class="text-right" placeholder="Search customer..." />
									<mat-autocomplete #autoTo="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setTo($event.option.value)">
										<mat-option *ngFor="let option of toresults" [value]="option">
											<b>{{ option.debtorno }}</b> - {{ option.name }}
										</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>

							<div class="col-md-12">
								<ng-container *ngIf="!matrix">
								  <div class="alert alert-secondary p-3 rounded shadow-sm border">
									<h5 class="mb-2">
									  <i class="fa fa-info-circle text-white bg-primary p-1 rounded-circle"></i>
									  Customer Matrix Copy Instructions
									</h5>
									<p class="mb-1">
									  Please select both a <strong>Customer From</strong> and a <strong>Customer To</strong>.
									</p>
									<p class="small mb-2">
									  This will copy the customer matrix from Customer A to Customer B.
									</p>
									<p class="text-danger font-weight-bold mb-0">
									  <i class="fa fa-warning"></i>
									  The selected Customer From must already have matrix pricing.
									</p>
								  </div>
								</ng-container>



								<ng-container *ngIf="matrix">
									<div class="text-right mb-3" *ngIf="from && to">
										<h4 *ngIf="warning" class="text-danger">{{ warning }}</h4>
										<button mat-raised-button color="accent" class="btn btn-primary mt-2 mb-2" (click)="copyMatrix()">
											<i class="fa fa-send"></i>&nbsp;&nbsp;Proceed with Copy
										</button>
									</div>

									<div class="table-responsive table-bordered fixTableHead" #print_table>
										<table class="table table-fixed table-hover">
											<thead class="thead-dark">
												<tr>
													<th>Product Line</th>
													<th>Price Level</th>
													<th>Discount %</th>
												</tr>
											</thead>
											<tbody>
												<ng-container *ngIf="matrix.customer_matrix?.length > 0; else noMatrixRows">

													<tr *ngFor="let t of matrix.customer_matrix" >
													  <td class="text-center">{{ t.lineid }}</td>
													  <td class="text-center">{{ t.pricing_level }}</td>
													  <td class="text-center">{{ t.discount }}</td>
													</tr>


												</ng-container>
												<ng-template #noMatrixRows>
													<tr>
													  <td colspan="3" class="text-center no-matrix-message">
														No matrix data found for this customer.
													  </td>
													</tr>
												</ng-template>
											</tbody>

										</table>
									</div>
								</ng-container>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>